// The Email Spy section's numbers, from the competitors and how many emails
// each sent in the chosen dates. The status comes from watchReadiness, so it
// always agrees with the Email Spy pages.
import { watchReadiness } from "../Spy/spyWatch";

// spyReport returns the totals, and a row per competitor: busiest in the dates
// first, then by name.
export function spyReport(watches, emailsByWatch) {
  const emails = new Map((emailsByWatch || []).map((w) => [w.watch_id, w.emails || 0]));
  const rows = (watches || []).map((w) => {
    const { ready, status } = watchReadiness(w);
    return { id: w.id, name: w.name, ready, status, emails: emails.get(w.id) || 0, unread: w.unread_count || 0 };
  }).sort((a, b) => b.emails - a.emails || (a.name || "").localeCompare(b.name || ""));

  const working = rows.filter((r) => r.ready).length;
  return {
    rows,
    competitors: rows.length,
    working,
    needAttention: rows.length - working,
    emails: rows.reduce((sum, r) => sum + r.emails, 0),
    unread: rows.reduce((sum, r) => sum + r.unread, 0),
  };
}
